import React, { FC } from 'react';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import PosterTeaser from '#components/teasers/poster-teaser/PosterTeaser';
import AudioTeaser from '#components/teasers/audio-teaser/AudioTeaser';
import SquareTeaser from '#components/teasers/square-teaser/SquareTeaser';
import DefaultTeaser from '#components/teasers/default-teaser/DefaultTeaser';
import { ContentType, MediaType } from '#types/generated/graphql-types';

const TeaserGridTeaserRenderer: FC<ITeaserRenderer> = (props) => {
  const data = props.teaserDataRaw;

  if (data.__typename === 'Category' || data.__typename === 'Studio') {
    return <SquareTeaser teaserDataRaw={data} />;
  }

  if (data.__typename === 'Series') {
    return <PosterTeaser teaserDataRaw={data} />;
  }

  if (data.__typename === 'Media' && data.mediaType === MediaType.Episode) {
    return <DefaultTeaser teaserDataRaw={data} />;
  }

  if (data.__typename === 'Media' && data.contentType === ContentType.Audio) {
    return <AudioTeaser teaserDataRaw={data} />;
  }

  return (
    <PosterTeaser teaserDataRaw={data} onMouseEnter={props?.onMouseEnter} />
  );
};

export default TeaserGridTeaserRenderer;
